<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Dashboard</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item active">Home</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-6">
            <div class="card">
              <div class="card-header">User statistics</div>
              <div class="card-body p-0 mb-3">
                <pie-chart :chart-data="pieUserStatistics"></pie-chart>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="card">
              <div class="card-header">Top 5 Courses with highest watch time</div>
              <div class="card-body p-0 mb-3">
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                    <tr>
                      <th>Course Name</th>
                      <th>Watch Time (in minutes)</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(val, index) in topCoursesWatchTime">
                      <td>{{ val.course.course_title }}</td>
                      <td class="text-center">{{ val.total_watch_time }}</td>
                    </tr>
                    </tbody>
                  </table>
                  <div class="p-4" v-if="_.isEmpty(topCoursesWatchTime)" >
                    <div class="alert alert-default-warning" role="alert">
                      No data found!
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import localStorage from '@/services/localStorage'
import {CommonAPI, LearningReportApi} from '@/services/api'
import SortIcons from "@/components/utils/SortIcons.vue"

export default {
  name: 'Dashboard',
  metaInfo: {
    title: 'Dashboard | Dotlines'
  },
  components: {
    SortIcons,
    PieChart: () => import('@/components/charts/PieChart.vue')
  },
  data: () => ({
    pieUserStatistics: {},
    topCoursesWatchTime: {},
  }),
  mounted() {
    if (this.isMobile()) {
      window.$(document).find('.push-menu-class').trigger('click')
    }
    const windowReload = localStorage.get('window_reload')
    if (windowReload) {
      localStorage.set('window_reload', false)
      window.location.reload()
    }
    this.getUserStatistics()
    this.topNCoursesWatchTime()
  },
  methods: {
    async getUserStatistics() {
      let _this = this
      await CommonAPI.getUserStatistics().then(statistics => {
        // Filter out the "message" key from the object
        const {message, total_user_count, ...counts} = statistics

        const labels = Object.keys(counts).map((key) => {
          return key.replace(/_count/g, '').replace(/_/g, ' ').replace(/\b\w/g, (match) => match.toUpperCase())
        })
        const values = Object.values(counts)

        _this.pieUserStatistics = {
          'labels': labels,
          'datasets': [{
            'borderColor': [
              'rgba(54, 162, 235, 1)',
              'rgba(255,99,132,1)'
            ],
            'backgroundColor': [
              'rgba(54, 162, 235, 0.2)',
              'rgba(255, 99, 132, 0.2)'
            ],
            'borderWidth': 1,
            'data': values,
          }]
        }
      })
    },
    topNCoursesWatchTime() {
      let _this = this
      LearningReportApi.topNCoursesWatchTime(5).then(statistics => {
        _this.topCoursesWatchTime = statistics
      })
    }
  }
}
</script>
